'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Controllable from '../decorators/Controllable';
import ShareInput from '../decorators/ShareInput';
import { INPUT_SIZE_OPTIONS, USE_CLASSES } from './InputConstants';
import refObject from '../utils/propTypes/refObject';
import { FieldsetContext } from '../context/FieldsetContext';

var UITextArea = /*#__PURE__*/function (_PureComponent) {
  _inherits(UITextArea, _PureComponent);

  function UITextArea() {
    _classCallCheck(this, UITextArea);

    return _possibleConstructorReturn(this, _getPrototypeOf(UITextArea).apply(this, arguments));
  }

  _createClass(UITextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          error = _this$props.error,
          inputRef = _this$props.inputRef,
          resize = _this$props.resize,
          styled = _this$props.styled,
          use = _this$props.use,
          rest = _objectWithoutProperties(_this$props, ["className", "error", "inputRef", "resize", "styled", "use"]);

      var fieldSize = this.context.size;
      var computedClassName = classNames("form-control private-form__control private-text-area", className, INPUT_SIZE_OPTIONS[fieldSize], USE_CLASSES[use], !styled && 'private-form__control--unstyled', error && 'private-form__control--error', resize === false && 'private-text-area--no-resize', {
        'vertical': 'private-text-area--vertical-resize',
        'horizontal': 'private-text-area--horizontal-resize'
      }[resize]);
      var renderedTextArea = React.createElement("textarea", Object.assign({}, rest, {
        className: computedClassName,
        ref: inputRef
      }));
      return renderedTextArea;
    }
  }]);

  return UITextArea;
}(PureComponent);

UITextArea.contextType = FieldsetContext;
UITextArea.displayName = 'UITextArea';
UITextArea.propTypes = {
  cols: PropTypes.number,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  inputRef: refObject,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  resize: PropTypes.oneOf(['vertical', 'horizontal', true, false]),
  rows: PropTypes.number,
  styled: PropTypes.bool.isRequired,
  use: PropTypes.oneOf(Object.keys(USE_CLASSES)),
  value: PropTypes.string
};
UITextArea.defaultProps = {
  error: false,
  resize: 'vertical',
  styled: true,
  value: ''
};
export default ShareInput(Controllable(UITextArea));